import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ImportarContactosExcel from '../../components/importarContactosExcel/ImportarContactosExcel'
import {submitImportarContactosExcel, cerrarModalImportarContactosExcel, subirArchivosImportarContactosExcel, abrirModalImportarContactosExcel, descargarPlantillaExcelContactosExcel} from '../../actions/importarContactosExcel/importarContactosExcel'

export function mapStateToProps (state) {
  return {
    ...state.importarContactosExcel,
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      submitImportarContactosExcel,
      cerrarModalImportarContactosExcel,
      subirArchivosImportarContactosExcel,
      abrirModalImportarContactosExcel,
      descargarPlantillaExcelContactosExcel
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ImportarContactosExcel))